import cn from 'classnames'
import { ImgHTMLAttributes } from 'react'

import styles from './VendorLogo.module.css'

const VendorLogo = ({ className, ...props }: ImgHTMLAttributes<HTMLImageElement>) => (
  <img className={cn(styles.vendorLogo, className)} {...props} />
)

export default VendorLogo
